import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cancelImg from "../assets/images/cancel.svg";
import {
  clearSearch,
  setFilterSearch,
  setFilterType,
  setPage
} from "../features/filter/filterSlice";

const FilterTransaction = () => {
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch();
  const { type, search } = useSelector((state) => state.filter || {});

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(setFilterSearch(searchText));
    dispatch(setPage(1));
    setSearchText("");
  };

  const handleFilterSelect = (text) => {
    dispatch(setFilterType(text));
    dispatch(setPage(1));
  };

  const handleClearSearch = () => dispatch(clearSearch());

  return (
    <>
      <div className="filterSection">
        <div className="filterOption">
          <div
            className={`radio_group ${
              type === "income" ? "opt-1-checked" : ""
            }`}
          >
            <input
              type="radio"
              value="income"
              name="type"
              id="opt-1"
              checked={type === "income"}
              readOnly
              onClick={(e) => handleFilterSelect("income")}
            />
            <label htmlFor="opt-1">Income</label>
          </div>
          <div
            className={`radio_group ${
              type === "expense" ? "opt-2-checked" : ""
            }`}
          >
            <input
              type="radio"
              value="expense"
              name="type"
              id="opt-2"
              checked={type === "expense"}
              readOnly
              onClick={(e) => handleFilterSelect("expense")}
            />
            <label htmlFor="opt-2">Expense</label>
          </div>
        </div>
        <form onSubmit={onSubmit}>
          <input
            type="text"
            placeholder="Search with title"
            value={searchText}
            onChange={(e) => setSearchText(e?.target?.value)}
          />
        </form>
      </div>
      {search && (
        <div style={{ minWidth: "400px" }}>
          <div onClick={handleClearSearch} className="searchText">
            {search} <img className="cancelImg" src={cancelImg} alt="cancel" />
          </div>
        </div>
      )}
    </>
  );
};

export default FilterTransaction;
